<template>
    <div class="row justify-end items-center">

        <div style="min-width: 170px" :class="{'full-width' : fullWidth}">
            <q-select v-model="selectedCurrency"
                      autocomplete="off"
                      @input="syncCurrency"
                      :loading="getCurrenciesPending"
                      :options="currencies"
                      :readonly="isLoggedIn"
                      :bg-color="!isLoggedIn ? 'white' : ''"
                      option-value="key"
                      option-label="value"
                      label="Currency"
                      outlined dense options-dense>
                <template v-slot:append>
                    <img :src="getCurrencyFlag" class="img-flag rounded" />
                </template>
                <q-tooltip v-if="isLoggedIn">
                    Currency has been set to match your account profile location settings
                </q-tooltip>
            </q-select>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'currency-select',
        props: {
            fullWidth: Boolean,
        },
        data() {
            return {
                currencyFlags: {
                    usa: require('@/assets/img/flags/usa.png'),
                    canada: require('@/assets/img/flags/canada.png')
                },
                currencies: [],
                selectedCurrency: null,
            }
        },
        methods: {
            getCurrencies() {
                if (!!this.currencies.length) {
                    this.selectedCurrency = this.currencies?.find(c => c.key == this.cart.currency)
                    return
                }
                this.$store.dispatch('getCurrencies').then(() => {
                    if (this.getCurrenciesData && typeof this.getCurrenciesData !== 'undefined') {
                        this.currencies = this.getCurrenciesData
                        this.selectedCurrency = this.currencies?.find(c => c.key == this.cart.currency)
                    }
                })
            },
            syncCurrency() {
                this.$store.dispatch('updateCurrency', this.selectedCurrency.key)
            }
        },
        computed: {
            ...mapState([
                'getCurrenciesData',
                'getCurrenciesPending',

                'getAccountInfoData',
                'getAccountInfoPending',

                'updateCartCustomerData',
                'updateCartCustomerPending',
            ]),
            cart() { return this.$store.getters.cart },
            getCurrencyFlag() {
                if (this.selectedCurrency) {
                    if (this.selectedCurrency.value == 'USD') {
                        return this.currencyFlags.usa
                    }
                    else if (this.selectedCurrency.value == 'CAD') {
                        return this.currencyFlags.canada
                    }
                }
                return ''
            },
            isLoggedIn() { return this.$store.getters.isLoggedIn },
        },
        created() {
            this.getCurrencies()
            if (this.isLoggedIn) {
                var user = JSON.parse(localStorage.getItem('user')) || null

                if (user) {
                    this.$store.dispatch('getAccountInfoByEmail', user.username).then(() => {
                        this.$store.dispatch('updateCartCustomer', this.getAccountInfoData)
                    })
                }
            }
        },
        watch: {
            'cart.currency'(newVal) {
                if (!!this.currencies.length)
                    this.selectedCurrency = this.currencies?.find(c => c.key == newVal)
            }
        }
    }
</script>
<style scoped>
    .img-flag {
        max-height: 35px;
    }
</style>
